import React from 'react';
import styled from 'styled-components';
import { space, width, maxWidth } from 'styled-system';
import gridConfig from '../../themes/GridConfig';

const { offsets, maxWidths } = gridConfig;
const StyledContainer = styled.div(
  {
    boxSizing: 'border-box',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  maxWidth,
  space,
  width
);

function Container(props) {
  const { children, ...other } = props;

  return (
    <StyledContainer maxWidth={maxWidths} px={offsets} {...other}>
      {children}
    </StyledContainer>
  );
}

// Redefine the propTypes from styled system
Container.propTypes = {
  ...maxWidth.propTypes,
  ...space.propTypes,
  ...width.propTypes,
};

/* @component */
export default Container;
